'use client';

import { useEffect } from 'react';
import { gtmService } from '@/util/gtm-service';

interface ExpiredEntryAnalyticsProps {
  entryId: number;
  title: string;
  categoryId: number;
  categoryName: string;
  parentCategoryId: number | null;
  parentCategoryName: string | null;
}

export function ExpiredEntryAnalytics({
  entryId,
  title,
  categoryId,
  categoryName,
  parentCategoryId,
  parentCategoryName,
}: ExpiredEntryAnalyticsProps) {
  useEffect(() => {
    gtmService.event('expired_item:view', {
      entry: entryId,
      title,
      category: categoryId,
      category_name: categoryName,
      category_id: parentCategoryId,
      parent_category_name: parentCategoryName,
    });
  }, [entryId, title, categoryId, categoryName, parentCategoryId, parentCategoryName]);

  return null;
}
